import AbstractCommand from "../../../core/application/AbstractCommand";
import FileModel from "../model/FileModel";

export default class FileAvailableCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {FileModel} fileModel 
     */
    constructor(dispatcher, fileModel) {
        super(dispatcher);

        this._fileModel = fileModel;
    }

    execute(evt) {
        const data = evt.params.data;
        const file = data.content;
        this._fileModel.addFile(file);
    }
}